import Agenda from '../Components/Agenda';
import { auth } from '../Utils/firebaseConfig'
import { useState } from 'react';

import './LogIn.css';

const AgendaView = () => {
  const [isLoggedin, setIsLoggedIn] = useState(false)

  auth.onAuthStateChanged((user) => {
    if (user) {
      setIsLoggedIn(!!user);
    } else {
      window.location.href = '/'
    }
  });
  return (
    <div>
      {isLoggedin ? (
        <Agenda />
      ) : <></>}
    </div>
  );
}

export default AgendaView;
